module.exports = __webpack_public_path__ + "static/media/menorah.44280f91.svg";